import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ResultComponent from './components/ResultComponent/ResultComponent';
import Dashboard from './components/Dashboard';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={<Dashboard />}
          />
          <Route
            path="/invalid-document"
            element={<ResultComponent title="Document Verification Failed , Invalid Document. " />}
          />
          <Route
            path="/unauthorized"
            element={<ResultComponent title="Security Veification Failed , Unauthorized Access."
              subTitle={" If you believe you should have access to this document please logout and login again. Incase the issues persists please contact the document owner."} />}
          />
          <Route
            path="/no-internet"
            element={<ResultComponent title="No Internet, Check your internet connection." />}
          />
          <Route
            exact path="/:id"
            element={<App />}
          >
          </Route>
          <Route
            exact path="/template/:id"
            element={<App isTemplateDocument={true} />}
          >
          </Route>
          <Route
            exact path="/external/:id"
            element={<App isExternal={true} />}
          >
          </Route>
        </Routes>
      </Router>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
